import axios from "@/utils/axiosHelper";

// 短信登陆
export const LoginBySmsAPI = (data) => {
  return axios({ url: "/login/sms", method: "POST", data });
};

// 账户密码登陆
export const LoginByAccountAPI = (data) => {
  return axios({ url: "/login/account", method: "POST", data });
};

// 渠道登陆
export const LoginByChannelAPI = (data) => {
  return axios({ url: "/game/binds/channel", method: "POST", data });
};

// 登出
export const LogoutAPI = (data) => {
  return axios({ url: "/game/my/disable", method: "POST", data });
};

// 获取验证码
export const GetCodeAPI = (data) => {
  return axios({ url: "/login/lt/code/dispatch", method: "POST", data });
};

// 免密短信登陆
export const LoginBySmsFreeAPI = (data) => {
  return axios({ url: "/login/free/sms", method: "POST", data });
};

// 免密账户密码登陆
export const LoginByAccountFreeAPI = (data) => {
  return axios({ url: "/login/free/pwd", method: "POST", data });
};



// WEBPACK FOOTER //
// ./src/api/login.js